import config from '@/config'
import { Heading, Link, VStack } from '@chakra-ui/react'
import { useLocation, useNavigate } from 'react-router-dom'

const ExternalRedirectPage = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const externalRedirectLink = `${config.externalURL}${location.pathname.replace('/subcontractors', '')}${location.search}`
  return (
    <VStack h="100vh" w="100vw" role="alert" justifyContent="center" alignItems="center" spacing="20px">
      <Heading>We have moved to another site, please click the following link to access E-Approval</Heading>
      <Link href={externalRedirectLink} textDecor={'underline'} color="blue.400" target={'_blank'}>
        Go
      </Link>
    </VStack>
  )
}

export default ExternalRedirectPage
